import { render, staticRenderFns } from "./addFactoryDrawer.vue?vue&type=template&id=28c59212&"
import script from "./addFactoryDrawer.vue?vue&type=script&lang=js&"
export * from "./addFactoryDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports